import { render, staticRenderFns } from "./ListJigyoshoGinko.vue?vue&type=template&id=4a0dec3b&"
import script from "./ListJigyoshoGinko.vue?vue&type=script&lang=ts&"
export * from "./ListJigyoshoGinko.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports